
import { Vue, Component } from "vue-property-decorator";
import { apiMuheConfig, apiMuheConfigEdit } from "@/api/setting";

@Component
export default class MuheConfig extends Vue {
    /** S Data **/
    // 表单数据
    form: any = {
        zhiwen_appKey: "",
        zhiwen_appSecret: "",
        laozicloud_appKey: "",
        laozicloud_appSecret: "",
    };

    // 表单验证
    rules: object = {
        zhiwen_appKey: [{required: true,message: "请输入指纹平台AppKey",trigger: "blur",},],
        zhiwen_appSecret: [{required: true,message: "请输入指纹平台AppSecret",trigger: "blur",},],
        laozicloud_appKey: [{required: true,message: "请输入老子云AppKey",trigger: "blur",},],
        laozicloud_appSecret: [{required: true,message: "请输入老子云AppSecret",trigger: "blur",},],
    };
    /** E Data **/

    /** S Methods **/
    // 初始化表单数据
    async initFormData(): Promise<void> {
        const res: any = await apiMuheConfig()
        for (const key in res) {
            this.form[key] = res[key];
        }
    }

    // 重置表单数据
    onResetFrom() {
        this.initFormData();
        this.$message.info("已重置数据");
    }

    // 提交表单
    onSubmitFrom(formName: string) {
        const refs = this.$refs[formName] as HTMLFormElement;

        refs.validate(async (valid: boolean): Promise<void> => {
            if (!valid) return;
            const loading = this.$loading({ text: "保存中" });

            await apiMuheConfigEdit({
                ...this.form,
            }).finally(() => {
                loading.close();
            });
            this.$store.dispatch("getConfig");
        });
    }
    /** E Methods **/

    /** S Life Cycle **/
    created() {
        this.initFormData();
    }
    /** E Life Cycle **/
}
